// Fun layer: item "rarity" badges + a spinnable Fridge Personality.

export function rarityFor(item) {
  const c = item.confidence || 0;
  if (item.status === "gone") {
    return c >= 75
      ? { label: "Cleanly Vanished", tone: "gone" }
      : { label: "Presumed Missing", tone: "gone" };
  }
  if (item.status === "new") {
    return c >= 75
      ? { label: "Fresh Arrival", tone: "new" }
      : { label: "New Face", tone: "new" };
  }
  // still_here — the squatters
  if (c >= 80) return { label: "Serial Squatter", tone: "squatter" };
  if (c >= 55) return { label: "Long-Term Tenant", tone: "squatter" };
  return { label: "Ancient Leftover", tone: "squatter" };
}

export function personalityFor(result) {
  const items = result?.items || [];
  const gone = items.filter((i) => i.status === "gone").length;
  const neu = items.filter((i) => i.status === "new").length;
  const stay = items.filter((i) => i.status === "still_here").length;
  const total = items.length;

  if (total === 0) return { title: "The Enigma", blurb: "Your fridge gives nothing away." };
  if (stay >= 3 && stay >= gone && stay >= neu)
    return { title: "The Hoarder", blurb: "Nothing ever leaves. It just... settles in." };
  if (neu >= 2 && neu > gone)
    return { title: "The Restocker", blurb: "Always topping up, rarely finishing." };
  if (gone >= 2 && gone > neu)
    return { title: "The Purger", blurb: "You clear house without mercy." };
  if (total <= 1) return { title: "The Minimalist", blurb: "Lives on air and one lone condiment." };
  return { title: "The Regular", blurb: "A healthy churn of snacks and secrets." };
}
